import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { NeedOfDisabilityService } from '@ascschool/services/category/need-of-disability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { MaritalStatusService } from '@ascschool/services/school/marital-status.service';
import { CaregiverService } from '@ascschool/services/category/caregiver.service';
import { LivingConditionService } from '@ascschool/services/category/living-condition.service';
import { LevelOfDevelopmentTypesService } from '@ascschool/services/school/level-of-development-types.service';
import { CadisInterventionStatussService } from '@ascschool/services/category/cadis-Intervention-Statuss.service';
@Component({
  selector: 'app-bao-cao-thong-ke-nkt-do-tuoi',
  templateUrl: './bao-cao-thong-ke-nkt-do-tuoi.component.html',
  styleUrls: ['./bao-cao-thong-ke-nkt-do-tuoi.component.scss']
})
export class BaoCaoThongKeNKTCoGiayChungNhanComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef, public _authService: AuthService, public sizePageService: SizePageService,
    private authQuery: AuthQuery, public utilService: UtilsService, private service: BaocaoService,
    private caDisNeedOfDisabilitysService: NeedOfDisabilityService, private disProvincesService: ProvinceService,
    private districtService: DistrictService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
   }
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  @ViewChild('pageHeaderTable3', { static: false }) set content3(content3: ElementRef) {
    if (content3) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable3 = content3;
    }
  }
  @ViewChild('pageHeaderTable4', { static: false }) set content4(content4: ElementRef) {
    if (content4) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable4 = content4;
    }
  }
  $unSubscribe= new Subject();
  year: any = new Date;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  dataTable: any[] = [];
  firstRowOnPage: any;
  width: number;
  numberControl: number;
  header1Arr: any[] = [];
  header2Arr: any[] = [];
  header3Arr: any[] = [];
  keys: any[] = [];
  currentUser: any;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  private elementPageHeaderTable3: ElementRef;
  private elementPageHeaderTable4: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  listYearOld = [
    { value: 1, name: "0-5 tuổi" }, 
    { value: 2, name: "6-18 tuổi" },
    { value: 3, name: "19-60 tuổi" }, 
    { value: 4, name: "Trên 60 tuổi" },
  ];
  show = false; maxHeight: number; height: number; heightPopup: number; heightPagnagation: number = 50; isCollapse = true; sum = 0;
 
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl(); 
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        
        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
  
      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) { 
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          }); 
        }
      });
    }
    // if (this.currentUser.accountType === 1) {
    //   this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    // } else {
    //   this.commonFilter.subordinateTypeId = 0;
    // }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName }); 
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        } 
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      }); 
    }
    this.reload();
    this.loadDisProvinces();
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0]; 
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    if(this.commonFilter.AgeId === null){
      delete this.commonFilter.AgeId;
    }
    this.commonFilter.year = this.year;
    this.resetData();
    this.service.getRpTkSlNktGcnTnt(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        if (response.data === null && response.pivotDt === null) {
          _this.dataTable = [];
        } else {
          this.resetData();
          this.handlingData(response);
          this.dataTable = response.data; 
        }
        _this.loading = false;
      }, () => {
        _this.dataTable = [];
        _this.loading = false;
      }
    );
  }
  handlingData(response: any) {
    this.sum = 0;
    let rowHeader1 = [
     
      { id: 1, dataName: "Độ tuổi", idChild: 'doTuoi', colSpan: 1 },
      
    ];
     
    let rowHeader2 = [];
    let rowHeader3 = [];
    let data = [];
    let keys = Object.keys(response); 
    
   
    //header 2
    keys.forEach(key => {  
      rowHeader1.forEach(h1 => {
        if (key === h1.idChild && response[key]) {
          h1.colSpan = response[key].length * 2;
          response[key].forEach(elementH2 => { 
            rowHeader2.push({ dataName: elementH2.dataName, id: key + elementH2.id, colSpan: 2 });
          });
        }
        if (key === h1.idChild && response[key] === null) {
          h1.colSpan = 2;
          rowHeader2.push({ dataName: '', id: null, colSpan: 2 });
        }
      }); 
    });
    keys.forEach(key => {  
      if (key === 'doTuoiSl' && response[key]) { 
        response[key].forEach(element => {
          rowHeader3.push({ dataName: element.dataName, id: key + element.id, colSpan: 2 });
           
        });
      }
    });

    data.push({ dataName: 'Tổng', total: this.sum }); 
    this.header1Arr = rowHeader1;
    this.header2Arr = rowHeader2;    
    
    
    
    this.dataTable = data;
  }

  resetData() {
    this.dataTable = [];
    this.header1Arr = [];
    this.header2Arr = [];
    this.header3Arr = [];
    this.keys = [];
  }
  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportRpTkSlNktGcnTnt(this.commonFilter).subscribe((data:any) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'thttnkt.xlsx';
      link.click();
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.heightfnc();
    }, 500);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => console.log('hi'),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 250 + 100 * this.header2Arr.length * 2;
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.elementPageHeaderTable3,
      this.elementPageHeaderTable4,
      this.heightPagnagation
    );
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
  }

  clear() {  
    delete this.commonFilter.AgeId;
    delete this.commonFilter.DisDisabilityCertificateType;
    this.year = '';
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    
    this.reload();
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') {
      return control.value.id;
    }
    return '';
  }
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) =>
      this.disProvincesService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null); 
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) =>
      this.districtService.getDistrictSelectPaging({
        searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
      }).pipe(map((resp) => resp.results.length > 0
        ? resp.results.map((x) => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) { 
    }
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
